/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Button } from 'antd';

const OlympicGridCard = ({ index, exercise, onClick }) => {
  return (
    <div className="bg-white d-flex flex-grow-1 flex-column" style={{ borderRadius: 5, height: '100%', border: `1px solid ${exercise.color[index]}` }}>
      <div className="d-flex py-2 px-2 align-items-center">
        <div className="d-flex align-items-center justify-content-center mr-2" style={{ marginLeft: -12, fontSize: 18, fontWeight: 700, font: '700 "Trebuchet MS",sans-serif', background: exercise.color[index], color: 'white', width: 45, height: 40, borderRadius: '0px 30px 30px 0px' }}>{exercise.tagName}</div>
        <div style={{ fontSize: 26, color: exercise.color[index] }}>{exercise.title}</div>
      </div>
      <div className="d-flex flex-grow-1 flex-column justify-content-center px-3 pt-1 pb-3">
        <div style={{ flex: 1 }}>
          {exercise.skills.map((item, i) => {
            const isLast = exercise.skills.length - 1 !== i;
            return (
              <React.Fragment key={i}>
                <span>{item.visible && item.name}</span>
                {isLast && <span>, </span>}
              </React.Fragment>
            );
          })}
        </div>
        <Button onClick={onClick} className="py-2 my-2" style={{ background: exercise.color[index], color: 'white', height: 'fit-content', fontWeight: 600 }}>Bắt đầu luyện tập</Button>
      </div>
    </div>
  );
};

OlympicGridCard.propTypes = {

};

export default OlympicGridCard;
